var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tb-page"}},[_c('transition',{attrs:{"name":"router-anim","enter-active-class":`animated ${_vm.animated.enter} fastest`,"mode":"out-in","leave-active-class":`animated ${_vm.animated.exit} fastest`}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }